export type Lang = 'fr' | 'en';

export const LANGUAGES: { code: Lang; label: string }[] = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
];

type Dict = Record<string, string>;

const fr: Dict = {
  // brand / shell
  'brand.title': 'Évolution',
  'brand.subtitle': 'Espace Évolution',
  'nav.upcoming': 'Séances',
  'nav.admin': 'Admin',
  'common.logout': 'Déconnexion',
  'common.loading': 'Chargement…',
  'common.cancel': 'Annuler',
  'common.save': 'Enregistrer',
  'common.add': 'Ajouter',
  'common.back': 'Retour',
  'common.close': 'Fermer',
  'common.saving': 'enregistrement…',
  'common.search': 'Rechercher',
  'common.theme.light': 'Mode clair',
  'common.theme.dark': 'Mode sombre',
  'common.language': 'Langue',
  'common.impersonating': 'Vous consultez en tant que',
  'common.impersonatingBy': 'imitation par',
  'common.stopImpersonating': 'Arrêter l’imitation',
  'shell.devBanner.label': 'Environnement DEV',
  'shell.devBanner.text': 'Environnement de test — ce qui est saisi ici n’est pas repris dans l’application et peut être écrasé à tout moment. Pour les séances réelles, utilisez :',

  // login
  'login.title': 'Évolution',
  'login.subtitle': 'Espace Évolution — espace animateur',
  'login.oidcButton': 'Se connecter avec Authentik',
  'login.emailPlaceholder': 'votre.nom@aeveil.ch',

  // upcoming
  'upcoming.past': 'Séances passées',
  'upcoming.title': 'Séances',
  'upcoming.next': 'À venir',
  'upcoming.today': 'Aujourd’hui',
  'upcoming.showMore': 'Afficher {n} autres séances à venir',
  'upcoming.showLess': 'Masquer les séances plus lointaines',
  'upcoming.pastEmpty': 'Aucune séance passée.',
  'upcoming.badge.unopened': 'jamais ouverte ici',
  'upcoming.newAdHoc': 'Nouvelle séance ad-hoc',
  'upcoming.empty': 'Aucune séance à venir. Si vous animez un Topo Hebdo, vérifiez que votre adresse e-mail correspond à celle de votre fiche Éveil V2.',
  'upcoming.open': 'Ouvrir →',
  'upcoming.openSpace': 'Ouvrir l’espace',
  'upcoming.opening': 'Ouverture…',
  'upcoming.fill.complete': 'Complet',
  'upcoming.fill.partial': '{a}/{b} saisis',
  'upcoming.fill.todo': 'À saisir',
  'upcoming.enrolled': '{n} inscrit·e·s',
  'upcoming.source.scheduled': 'planifiée',
  'upcoming.source.recurrence': 'calculée à partir de la récurrence',
  'upcoming.source.adhoc': 'ad-hoc',
  'upcoming.source.bsp': 'bilan — rendez-vous individuel',
  'upcoming.source.intake': 'premier entretien / bilan socio-professionnel',
  'upcoming.badge.bilan': 'Bilan',
  'upcoming.badge.bspPlanned': 'BSP',
  'upcoming.bspNotRecorded': 'à saisir',
  'upcoming.modal.title': 'Nouvelle séance ad-hoc',
  'upcoming.modal.date': 'Date',
  'upcoming.modal.type': 'Type de séance',
  'upcoming.modal.typeEE': 'Espace Évolution',
  'upcoming.modal.typeBsp': 'Bilan / BSP',
  'upcoming.modal.titleField': 'Titre',
  'upcoming.modal.titlePlaceholder': 'p. ex. Espace Évolution — Lausanne',
  'upcoming.modal.location': 'Lieu (optionnel)',
  'upcoming.modal.create': 'Créer et ouvrir',
  'upcoming.modal.creating': 'Création…',

  // session
  'session.empty': 'Aucun participant pour l’instant.',
  'session.selectParticipant': 'Sélectionnez un participant pour enregistrer ses cartes, notes et observations.',
  'session.addParticipant': 'Ajouter un participant',
  'session.addNamePlaceholder': 'Nom',
  'session.presence.present': 'Présent',
  'session.presence.absent': 'Absent',
  'session.presence.expected': 'Attendu',
  'session.presence.added': 'Ajouté',
  'session.presence.not_recorded': 'Présence non renseignée',
  'session.status.open': 'ouvert',
  'session.observations': 'Observations :',
  'nav.collapse': 'Réduire',
  'nav.expand': 'Développer le menu',
  'session.progress': 'enregistrés',
  'session.progressHelp': 'Entrées complètes : présence renseignée et, pour les présents, les cinq observations.',
  'session.queueLabel': 'Participants',
  'session.recorded': 'Entrée complète',
  'editor.presence': 'Présence',
  'editor.prevSession': 'Séance précédente',
  'editor.prevSessionNone': 'Première séance enregistrée pour ce participant.',
  'editor.objectives': 'Objectifs de la mesure',
  'editor.objectivesNone': 'Aucun objectif enregistré dans V2 pour ce participant.',
  'editor.objectivesBy': 'd’ici le',

  'bsp.title': 'BSP',
  'bsp.source': 'Source',
  'bsp.sourceLocal': 'BSP enregistré dans Evolution.',
  'bsp.sourceV2': 'BSP repris d’Éveil V2 — enregistrez pour le reprendre dans Evolution.',
  'bsp.sourceNone': 'Aucun BSP existant — créez-en un.',
  'bsp.date': 'Date du BSP',
  'bsp.location': 'Lieu',
  'bsp.referent': 'Référent·e',
  'bsp.presence': 'Présences et charte',
  'bsp.mandantPresent': 'Mandant présent',
  'bsp.socialAssistantPresent': 'Assistant·e social·e présent·e',
  'bsp.charterSigned': 'Charte signée',
  'bsp.objectivesSet': 'Objectifs (mots du participant)',
  'bsp.formation': 'Formation',
  'bsp.health': 'Santé',
  'bsp.psychological': 'Situation psychologique',
  'bsp.family': 'Situation familiale',
  'bsp.medication': 'Médication',
  'bsp.hobbies': 'Centres d’intérêt',
  'bsp.availability': 'Disponibilités',
  'bsp.notes': 'Notes',
  'bsp.save': 'Enregistrer',
  'bsp.create': 'Créer le BSP',
  'bsp.loadError': 'Impossible de charger le BSP.',
  'bsp.saveError': 'Impossible d’enregistrer le BSP.',
  'editor.nextParticipant': 'Participant suivant',
  'session.status.closed': 'fermé',

  // editor
  'editor.cards': 'Cartes choisies',
  'editor.notes': 'Notes de contexte',
  'editor.notesPlaceholder': 'Qu’a partagé le participant ? Observations sur les cartes choisies…',
  'editor.observations': 'Observations',
  'editor.adhocLabel': 'Ad-hoc',
  'editor.history': 'Historique',
  'editor.copyReport': 'Copier le compte rendu',
  'editor.copyReportHelp': 'Copie les cartes choisies, les notes et les observations au format texte, prêt à coller dans un rapport.',
  'editor.copied': 'Copié !',

  // observation scales (level criteria live in src/shared/scoreDimensions.ts)
  'score.hoverHint': 'Survolez ou sélectionnez un niveau pour afficher ses critères détaillés.',
  'score.explainToggle': 'Afficher les explications',

  // feuille de séance
  'fds.backToSheet': 'Feuille de séance',
  'fds.open': 'Ouvrir →',
  'fds.noCards': 'aucune carte pour l’instant',
  'fds.card': 'carte',
  'fds.cards': 'cartes',

  // table d'aujourd'hui
  'cards.tableCaption': 'La table d’aujourd’hui',
  'cards.addCard': 'Ajouter une carte',
  'cards.wholeDeck': 'Tout le jeu…',
  'cards.browseDeck': 'Parcourir tout le jeu →',
  'cards.deckTitle': 'Tout le jeu de cartes',
  'cards.recurrence': 'Choisie {n} fois au fil des séances',
  'editor.trends': 'Tendances',
  'editor.timeline': 'Le fil des séances',
  'editor.prevOlder': 'Séance plus ancienne',
  'editor.prevNewer': 'Séance plus récente',
  'editor.objectivesTitle': 'Objectifs — dans les mots du participant',
  'editor.objectivesSource': 'Premier entretien / BSP du',
  'editor.objectivesInfos': 'Informations complémentaires',
  'editor.evolution': 'L’évolution de {name}',
  'editor.flipToHistory': 'Voir l’historique',
  'editor.flipToToday': 'Séance du jour',
  'editor.backCaption': 'L’historique de {name}',

  // rich notes
  'notes.toolbar': 'Mise en forme',
  'notes.bold': 'Gras',
  'notes.italic': 'Italique',
  'notes.underline': 'Souligné',
  'notes.ul': 'Liste à puces',
  'notes.ol': 'Liste numérotée',
  'notes.savedAt': 'Enregistré à',
  'notes.saveError': 'Échec de l’enregistrement — modifiez le texte pour réessayer',
  'notes.versions': 'Versions',
  'notes.versionsHelp': 'Enregistrer une version de la note ou revenir à une version précédente',
  'notes.saveVersion': 'Enregistrer une version',
  'notes.versionSaved': 'Version enregistrée',
  'notes.noVersions': 'Aucune version enregistrée.',
  'evo.observations': 'Observations · A → E',
  'evo.delta': 'Évolution',
  'participant.journal': 'Journal des séances',
  'participant.journal.empty': 'Aucune séance enregistrée pour l’instant.',
  'participant.intake.open': 'Détails du premier entretien',
  'common.showMore': 'voir plus',
  'common.showLess': 'voir moins',

  // copied report
  'report.title': 'ESPACE ÉVOLUTION — COMPTE RENDU',
  'report.participant': 'Participant',
  'report.session': 'Séance',
  'report.location': 'Lieu',
  'report.presence': 'Présence',
  'report.cards': 'CARTES CHOISIES',
  'report.notes': 'NOTES',
  'report.observations': 'OBSERVATIONS',
  'report.noCards': '(aucune carte)',
  'report.noNotes': '(aucune note)',
  'report.notScored': '(non évalué)',

  // card picker
  'cards.noPicks': 'Aucune carte choisie pour l’instant.',
  'cards.searchPlaceholder': 'Rechercher une carte…',
  'cards.noMatches': 'Aucun résultat.',
  'cards.picked': 'choisie',
  'cards.remove': 'Retirer',
  'cards.allCategories': 'Toutes',
  'cards.base': 'Base',
  'cards.supplementary': 'Supplémentaire',
  'cards.brand': 'L’Eveil',

  // admin
  'admin.title': 'Admin',
  'admin.tab.users': 'Utilisateurs',
  'admin.tab.roles': 'Rôles',
  'admin.tab.audit': 'Journal d’audit',
  'admin.tab.notifications': 'Notifications',
  'admin.tab.branding': 'Apparence',
  'admin.tab.cards': 'Cartes',
  'admin.tab.devdata': 'Données de test',
  'admin.devData.title': 'Recharger les données depuis la production',
  'admin.devData.help': 'Cet environnement de test a sa propre base de données. Ce bouton la remplace par une copie à l’instant de la base de production (séances, participants, observations, cartes). Les accès à cet environnement de test et son apparence sont conservés. La production n’est jamais modifiée.',
  'admin.devData.lastReload': 'Dernier rechargement :',
  'admin.devData.never': 'jamais',
  'admin.devData.button': 'Recharger depuis la production',
  'admin.devData.modalTitle': 'Remplacer les données de test ?',
  'admin.devData.modalWarning': 'Tout ce qui a été saisi dans cet environnement de test sera effacé et remplacé par une copie de la production. Cette opération est irréversible pour les données de test ; la production n’est pas touchée.',
  'admin.devData.typeReset': 'Saisissez RESET pour confirmer',
  'admin.devData.confirm': 'Remplacer les données de test',
  'admin.devData.running': 'Rechargement…',
  'admin.devData.done': 'Données rechargées depuis la production.',
  'admin.devData.failed': 'Le rechargement a échoué.',
  'cardver.title': 'Versions du Jeu de Cartes',
  'cardver.intro': 'Inventaire des cartes par version et lignée d’une version à l’autre.',
  'cardver.current': 'actuelle',
  'cardver.items': 'cartes',
  'cardver.number': 'N°',
  'cardver.name': 'Carte',
  'cardver.category': 'Catégorie',
  'cardver.metalabel': 'Type',
  'cardver.lineage': 'Devient (version suivante)',
  'cardver.dropped': 'abandonnée',
  'cardver.archived': 'archivée',
  'cardver.unchanged': 'inchangée',
  'cardver.renumbered': 'renumérotée',
  'cardver.loading': 'Chargement…',
  'admin.logo.title': 'Logo de l’application',
  'admin.logo.help': 'PNG carré recommandé, fond transparent, max 1,5 Mo. S’affiche dans la barre d’en-tête.',
  'admin.logo.none': 'Aucun logo',
  'admin.logo.upload': 'Téléverser un logo',
  'admin.logo.remove': 'Supprimer',
  'admin.logo.errPng': 'Seuls les fichiers PNG sont acceptés.',
  'admin.logo.errSize': 'Fichier trop volumineux (max 1,5 Mo).',
  'admin.accent.title': 'Couleur d’accent',
  'admin.accent.help': 'La couleur principale de l’application (boutons, liens, éléments actifs). S’applique immédiatement, en mode clair et sombre.',
  'admin.accent.custom': 'Couleur personnalisée',
  'admin.accent.reset': 'Rétablir le vert par défaut',

  // history modal
  'history.title': 'Historique du participant',
  'history.empty': 'Aucune séance précédente enregistrée pour ce participant.',
  'history.cardsOverTime': 'Cartes au fil du temps',
  'history.cardsHelp': 'Une ligne par carte distincte, une colonne par séance. Les motifs récurrents sautent aux yeux.',
  'history.recurrenceCount': 'occurrences',
  'history.scores': 'Évolution des observations',
  'history.sessions': 'Séances',
  'history.notes': 'Notes',
  'history.noPicks': '(aucune carte)',
  'history.noScore': '—',

  // mes participant-es
  'nav.myParticipants': 'Mes Participant-es',
  'participants.title': 'Mes Participant-es',
  'participants.empty': 'Aucun participant rencontré pour l’instant.',
  'participants.lastSession': 'Dernier Espace Évolution',
  'participants.nextSession': 'Prochain Espace Évolution',
  'participants.attendance': 'Présences',
  'participants.sessions': 'séances',
  'participants.session': 'séance',
  'participants.since': 'depuis',
  'participants.presencesOf': 'présences sur',
  'participants.themesTitle': 'Thèmes récurrents',
  'participants.upcoming': 'à venir',
  'participants.today': 'aujourd’hui',
  'participants.tomorrow': 'demain',
  'participants.inPrefix': 'dans',
  'participants.daysUnit': 'jours',
  'participants.cadence': 'Cadence',
  'participants.week': 'semaine',
  'participants.weeks': 'semaines',
  'participants.dayUnit': 'jour',
  'participants.firstMeeting': 'première rencontre',
  'participants.reference': 'Référence',
  'participants.referenceTitle': 'Vous êtes référent-e de mesure de ce participant.',
  'participants.noSessionsYet': 'aucune séance enregistrée',
  'participant.notFound': 'Participant introuvable.',
  'participant.objectives': 'Objectifs',
  'participant.objectives.local': 'Objectifs (mots du participant)',
  'participant.objectives.localSource': 'BSP saisi dans Evolution',
  'participant.objectives.own': 'Objectifs dans les mots',
  'participant.objectives.means': 'Moyens pour les atteindre',
  'participant.objectives.ownSource': 'Fiche premier entretien (BSP scanné)',
  'participant.objectives.intakeSource': 'Premier entretien / BSP',
  'participant.bspCards': 'Cartes choisies au BSP',
  'participant.objectives.structured': 'Objectifs du premier entretien',
  'participant.objectives.journal': 'Plans d’action',
  'participant.objectives.empty': 'Aucun objectif trouvé.',
  'participant.info': 'Premier entretien / BSP',
  'participant.info.empty': 'Aucune information complémentaire.',
  'participant.info.date': 'Entretien du',
  'participant.info.notes': 'Informations complémentaires',
  'participant.info.formation': 'Formation / parcours',
  'participant.info.health': 'Santé',
  'participant.info.psychological': 'Situation psychologique',
  'participant.info.family': 'Situation familiale',
  'participant.info.medication': 'Médication',
  'participant.info.hobbies': 'Loisirs et intérêts',
  'participant.info.availability': 'Disponibilités',
  'participant.picks.current': 'Cartes choisies',
  'participant.picks.history': 'Historique des cartes',
  'participant.picks.empty': 'Aucune carte choisie pour l’instant.',
  'participant.observations': 'Observations',
  'participant.observations.empty': 'Aucune observation enregistrée.',
  'participant.v2Unavailable': 'Données Éveil V2 indisponibles pour le moment.',

  // profile menu
  'profile.title': 'Profil',
  'profile.menuAria': 'Ouvrir le menu du profil',

  // login (kit labels)
  'login.emailLabel': 'E-mail',
  'login.passwordLabel': 'Mot de passe',
  'login.passwordPlaceholder': 'Saisissez votre mot de passe',
  'login.submit': 'Se connecter',
  'login.submitting': 'Connexion…',
  'login.footer.open': 'Inscription ouverte — le premier utilisateur devient administrateur',
  'login.footer.allowlist': 'Seules les adresses e-mail pré-approuvées peuvent se connecter',
  'login.err.emailRequired': 'L’adresse e-mail est requise',
  'login.err.passwordRequired': 'Le mot de passe est requis',
  'login.err.loginFailed': 'Échec de la connexion',
  'login.err.notAuthorized': 'Votre adresse e-mail n’est pas autorisée à accéder à cette application. Contactez un administrateur.',
  'login.err.oidcFailed': 'Échec de l’authentification. Veuillez réessayer.',
  'login.err.noEmail': 'Aucune adresse e-mail n’a été transmise par le fournisseur d’identité.',

  // admin — user management (kit labels)
  'users.regMode.title': 'Mode d’inscription',
  'users.regMode.open': 'Ouvert',
  'users.regMode.allowlist': 'Liste d’accès',
  'users.regMode.openHelp': 'Toute personne avec une adresse e-mail valide peut s’inscrire. Le premier utilisateur devient administrateur.',
  'users.regMode.allowlistHelp': 'Seules les adresses pré-approuvées peuvent se connecter.',
  'users.allowlist.title': 'Liste des e-mails autorisés',
  'users.allowlist.notEnforced': 'La liste n’est pas appliquée actuellement. Passez en mode Liste d’accès pour restreindre l’inscription.',
  'users.allowlist.helpEnforced': 'Seules ces adresses e-mail peuvent se connecter. Ajoutez les adresses avant la première authentification.',
  'users.allowlist.helpNotEnforced': 'Gérez les adresses en vue du passage en mode Liste d’accès.',
  'users.emailPlaceholder': 'email@exemple.ch',
  'users.namePlaceholder': 'Nom (optionnel)',
  'users.addToAllowlist': 'Ajouter à la liste',
  'users.createAccount': 'Créer le compte',
  'users.errValidEmail': 'Adresse e-mail valide requise',
  'users.col.email': 'E-mail',
  'users.col.status': 'Statut',
  'users.col.added': 'Ajouté le',
  'users.status.registered': 'Inscrit ({name})',
  'users.status.pending': 'En attente',
  'users.impersonate': 'Imiter',
  'users.remove': 'Retirer',
  'users.confirmRemoveEmail': 'Retirer « {email} » de la liste ?',
  'users.mgmt.title': 'Gestion des utilisateurs',
  'users.col.user': 'Utilisateur',
  'users.col.role': 'Rôle',
  'users.col.joined': 'Inscrit le',
  'users.badge.admin': 'Admin',
  'users.badge.user': 'Utilisateur',
  'users.removeAdmin': 'Retirer admin',
  'users.makeAdmin': 'Rendre admin',
  'users.roles': 'Rôles',
  'users.resetPassword': 'Réinitialiser le mot de passe',
  'users.delete': 'Supprimer',
  'users.confirmDelete': 'Supprimer l’utilisateur « {name} » ? Toutes ses données seront également supprimées.',
  'users.newPasswordPlaceholder': 'Nouveau mot de passe (min. 8 caractères)',
  'users.set': 'Définir',
  'users.saveRoles': 'Enregistrer les rôles',
  'users.errPasswordMin': 'Le mot de passe doit contenir au moins 8 caractères',
  'users.passwordResetDone': 'Mot de passe réinitialisé',

  // admin — audit log (kit labels)
  'audit.allActions': 'Toutes les actions',
  'audit.resourceType': 'Type de ressource',
  'audit.startDate': 'Date de début',
  'audit.endDate': 'Date de fin',
  'audit.searchPlaceholder': 'Rechercher…',
  'audit.search': 'Rechercher',
  'audit.clear': 'Effacer',
  'audit.col.time': 'Heure',
  'audit.col.user': 'Utilisateur',
  'audit.col.action': 'Action',
  'audit.col.resourceType': 'Type de ressource',
  'audit.col.resourceId': 'ID ressource',
  'audit.col.details': 'Détails',
  'audit.col.ip': 'IP',
  'audit.loading': 'Chargement…',
  'audit.empty': 'Aucune entrée de journal trouvée',
  'audit.loadFailed': 'Échec du chargement du journal d’audit',
  'audit.clickToExpand': 'Cliquer pour développer',
  'audit.totalEntries': '{n} entrées au total',
  'audit.pageOf': 'Page {page} sur {pages}',
  'audit.prev': 'Précédent',
  'audit.next': 'Suivant',

  // admin — notification preferences (kit labels)
  'notif.title': 'Préférences de notification',
  'notif.loading': 'Chargement des préférences…',
  'notif.sponsorBadge': 'Sponsor',
  'notif.all': 'Toutes les notifications',
  'notif.sponsoredOnly': 'Sponsorisées uniquement',

  // ── PV ae45 (2026-10): attribution, roster, per-card context, défi, usage ──
  'nav.cards': 'Cartes',
  'session.animatedBy': 'Animé par',
  'session.animatedByHelp': 'La personne qui anime la séance. Tout·e intervenant·e peut y saisir ; une saisie par quelqu’un d’autre est indiquée.',
  'session.you': 'vous',
  'session.recordedBy': 'saisi par',
  'session.addSearchPlaceholder': 'Rechercher une personne dans Éveil…',
  'session.addHelp': 'Tapez au moins deux lettres du nom. Le nom complet et la mesure sont affichés pour distinguer les homonymes.',
  'session.addNoResults': 'Aucune personne trouvée dans Éveil.',
  'session.addOnlyInMeasure': 'En mesure uniquement',
  'session.inMeasure': 'en mesure',
  'session.notInMeasure': 'hors mesure',
  'session.linkToEveil': 'Lier à Éveil',
  'session.linkToEveilHelp': 'Rattacher cette entrée à une fiche Éveil pour retrouver son historique.',
  'session.linkConflict': 'Cette personne est déjà dans la séance.',
  'session.removeParticipant': 'Retirer de la séance',
  'session.removeConfirm': 'Retirer {name} de cette séance ? L’entrée reste récupérable.',
  'session.removed': 'Retiré·es de la séance :',
  'session.removedBy': 'par',
  'session.restoreParticipant': 'Rétablir',
  'session.replaceAnimator': 'Remplacer l’animateur·rice',
  'session.replaceAnimatorHelp': 'Qui anime cette séance ?',
  'session.deck': 'Jeu',
  'session.deckHelp': 'Jeu de cartes utilisé pour cette séance — déduit des cartes prises si rien n’est précisé.',
  'session.deck.base': 'de base',
  'session.deck.complet': 'complet',
  'session.delete': 'Supprimer la séance',
  'session.deleteHelp': 'La séance passe à la corbeille ; elle reste restaurable.',
  'session.deleteConfirm': 'Supprimer cette séance ? Elle reste récupérable depuis la corbeille, en bas de la liste des séances.',
  'session.deleted': 'Séance supprimée',
  'session.deletedBy': 'par',
  'session.restore': 'Restaurer',
  'upcoming.scope': 'Portée',
  'upcoming.scope.mine': 'Mes séances',
  'upcoming.scope.all': 'Toutes les séances',
  'upcoming.trash': 'Corbeille · {n}',
  'upcoming.trashRestore': 'Restaurer',
  'upcoming.trashParticipants': '{n} participant·es',
  'upcoming.deletedBy': 'supprimée par',
  'editor.recap': 'Objectifs & BSP',
  'editor.recapNone': 'Aucun objectif ni BSP enregistré dans Éveil.',
  'editor.recapGoals': 'Mandant',
  'editor.recapProgression': 'Objectif intermédiaire :',
  'editor.recapBsp': 'BSP',
  'editor.recapBspCards': 'Cartes du BSP',
  'editor.pickMeta': 'Autour de chaque carte',
  'editor.pickMetaHelp': 'Pour chaque carte : ce qui a été dit (le contexte), l’horizon — court, moyen ou long terme — et les ateliers où la thématique peut se travailler.',
  'editor.contextPlaceholder': 'Ce qui a été dit autour de « {card} »…',
  'editor.horizon': 'Horizon',
  'editor.ateliers': 'Ateliers',
  'editor.ateliersProgramme': 'Au programme de {name}',
  'editor.ateliersOthers': 'Autres ateliers',
  'editor.ateliersNone': 'Aucun atelier au programme.',
  'editor.ateliersFilter': 'Rechercher un atelier…',
  'editor.defi': 'Défi de la semaine',
  'editor.defiPlaceholder': 'Un pas concret d’ici la prochaine séance, dans les mots de la personne…',
  'editor.prevDefi': 'Défi :',
  'evo.colourMix': 'Couleurs',
  'evo.neverTaken': 'Jamais prises :',
  'evo.noContext': 'pas de contexte',
  'evo.oldDeck': 'Ancien jeu',
  'report.animator': 'Animateur·rice',
  'report.ateliers': 'Ateliers :',
  'report.defi': 'DÉFI DE LA SEMAINE',
  'report.noDefi': '(aucun défi)',
  'participants.titleAll': 'Participant-es',
  'participants.scope': 'Portée',
  'participants.scope.mine': 'Les miens',
  'participants.scope.all': 'Tous',
  'participants.showArchived': 'Afficher les archivé·es',
  'participants.archived': 'Archivé·e',
  'participants.archivedHelp': 'Aucune séance depuis six mois, pas de référence ni de prochaine séance — ou masqué·e à la main.',
  'participants.hidden': 'Masqué·e',
  'participants.hide': 'Masquer de la liste',
  'participants.unhide': 'Réafficher',
  'participants.animators': 'Animateur·rices :',
  'usage.title': 'Usage des cartes',
  'usage.intro': 'Quelles cartes et quelles couleurs reviennent, lesquelles ne sortent jamais, lesquelles vont ensemble — la matière pour la refonte du jeu.',
  'usage.period': 'Période',
  'usage.period.all': 'Depuis le début',
  'usage.period.12m': '12 derniers mois',
  'usage.period.6m': '6 derniers mois',
  'usage.kpi.picks': 'cartes prises',
  'usage.kpi.entries': 'entrées avec cartes',
  'usage.kpi.sessions': 'séances',
  'usage.kpi.participants': 'participant·es',
  'usage.kpi.supplementary': 'jeu complet (cartes 41–55)',
  'usage.kpi.never': 'cartes jamais prises',
  'usage.byColour': 'Par couleur',
  'usage.byCard': 'Par carte',
  'usage.col.participantsShort': 'pers.',
  'usage.col.picks': 'Prises',
  'usage.col.participants': 'Participant·es',
  'usage.col.sessions': 'Séances',
  'usage.col.context': 'Avec contexte',
  'usage.col.last': 'Dernière prise',
  'usage.sort.picks': 'Tri : prises',
  'usage.sort.participants': 'Tri : participant·es',
  'usage.sort.sessions': 'Tri : séances',
  'usage.sort.last': 'Tri : dernière prise',
  'usage.sort.number': 'Tri : numéro',
  'usage.horizons': 'Horizons :',
  'usage.pairs': 'Cartes qui vont ensemble',
  'usage.pairsHelp': 'Paires prises par la même personne lors de la même séance — des pistes de doublons à fusionner.',
  'usage.never': 'Jamais prises',
  'usage.neverNone': 'Toutes les cartes actives ont été prises au moins une fois.',
  'evo.colours': 'Couleurs — cartes par couleur et par séance',
  'evo.more': 'de plus en plus',
  'evo.less': 'de moins en moins',
  'evo.same': 'stable',
  'evo.dimensions': 'Les cinq dimensions',
  'evo.synthesisNote': '✦ Synthèse par carte générée par l’IA à partir des contextes, notes et défis saisis — à relire avant usage.',
  'evo.synthesisPending': 'Synthèse par carte en cours de rédaction…',
  'evo.synthesisError': 'La synthèse par carte n’a pas pu être générée (service IA indisponible).',

  // ── Observatoire ──
  'nav.insights': 'Observatoire',
  'obs.title': 'Observatoire',
  'obs.intro': 'Ce que l’ensemble des Espaces Évolution raconte : quelles thématiques, ensemble, dans quel ordre, pour qui, avec quel mouvement — et qui enregistre quoi.',
  'obs.period': 'Période',
  'obs.period.all': 'Tout l’historique',
  'obs.period.365': '12 derniers mois',
  'obs.period.180': '6 derniers mois',
  'obs.period.90': '3 derniers mois',
  'obs.tab.overview': 'Vue d’ensemble',
  'obs.tab.together': 'Cartes ensemble',
  'obs.tab.journeys': 'Parcours',
  'obs.tab.profiles': 'Profils',
  'obs.tab.observations': 'Observations',
  'obs.tab.themes': 'Thèmes émergents',
  'obs.tab.adherence': 'Adhésion',
  'obs.kpi.participants': 'participant·es',
  'obs.kpi.sessions': 'séances',
  'obs.kpi.entries': 'entrées',
  'obs.kpi.entriesHelp': 'Une entrée = un·e participant·e à une séance, avec au moins une carte, une note, un défi ou une observation.',
  'obs.kpi.picks': 'cartes prises',
  'obs.kpi.picksPerEntry': 'cartes par entrée',
  'obs.kpi.contextRate': 'cartes avec contexte',
  'obs.kpi.defiRate': 'entrées avec défi',
  'obs.kpi.lettersRate': 'entrées avec observations',
  'obs.kpi.takesCards': 'prennent les cartes',
  'obs.kpi.repeatRate': 'cartes reprises',
  'obs.kpi.repeatHelp': 'Part des cartes déjà prises par la même personne lors d’une séance précédente : la continuité des thématiques.',
  'obs.overview.monthly': 'Les couleurs mois par mois',
  'obs.overview.monthlyHelp': 'Cartes prises chaque mois, empilées par couleur (12 derniers mois). Les saisons du programme et le poids relatif des familles de thématiques.',
  'obs.cardsWord': 'cartes',
  'obs.seancesWord': 'séances',
  'obs.peopleShort': 'pers.',
  'obs.daysWord': 'jours',
  'obs.none': 'Rien à montrer pour cette période.',
  'obs.card': 'Carte',
  'obs.overview.colours': 'Par couleur',
  'obs.overview.coloursHelp': 'Cartes prises et nombre de personnes distinctes par famille.',
  'obs.overview.topCards': 'Les cartes les plus prises',
  'obs.overview.rising': 'Ce qui monte',
  'obs.overview.falling': 'Ce qui baisse',
  'obs.overview.trendHelp': 'Part des entrées où la carte est prise : 3 derniers mois contre les 3 mois précédents (points de pourcentage).',
  'obs.together.entries': 'Calculé sur {n} entrées avec au moins deux cartes.',
  'obs.together.minSupport': 'Paires vues au moins',
  'obs.together.graph': 'La carte du jeu tel qu’il est joué',
  'obs.together.graphHelp': 'Chaque point est une carte (taille = fréquence, couleur = famille). Un trait relie deux cartes prises ensemble lors de la même séance plus souvent que le hasard ne le voudrait (lift > 1) ; plus le trait est épais, plus le lien est fort. Les amas sont des thématiques qui se tiennent.',
  'obs.together.communities': 'Les amas',
  'obs.together.communitiesHelp': 'Groupes de cartes qui s’attirent (propagation d’étiquettes sur le graphe). Candidats à des ateliers thématiques, ou à des fusions lors de la refonte du jeu.',
  'obs.together.colours': 'Familles prises ensemble',
  'obs.together.coloursHelp': 'Combien de séances ont réuni deux familles de couleurs.',
  'obs.together.pairs': 'Paires les plus fréquentes',
  'obs.together.pairsHelp': '« Attendu » = fréquence si les deux cartes étaient prises indépendamment ; lift = observé / attendu.',
  'obs.together.lift': 'Paires les plus liées',
  'obs.together.liftHelp': 'Les paires dont le lien dépasse le plus le hasard (au moins 4 occurrences).',
  'obs.together.n': 'Vues',
  'obs.together.expected': 'Attendu',
  'obs.journeys.from': 'Séance n',
  'obs.journeys.to': 'Séance n+1',
  'obs.journeys.threePlus': 'parcours de 3 séances et plus',
  'obs.journeys.meanLength': 'séances par personne',
  'obs.journeys.steps': 'transitions',
  'obs.journeys.stepsHelp': 'Paires de séances consécutives d’une même personne.',
  'obs.journeys.phases': 'Début, milieu, fin',
  'obs.journeys.phasesHelp': 'Chaque parcours de 3 séances et plus est coupé en trois tiers ; part de chaque couleur dans chaque tiers. La migration attendue des thématiques de fond vers le concret se lit ici.',
  'obs.phase.debut': 'Début',
  'obs.phase.milieu': 'Milieu',
  'obs.phase.fin': 'Fin',
  'obs.journeys.repeats': 'de cartes reprises',
  'obs.journeys.position': 'Où se place chaque famille dans le parcours',
  'obs.journeys.positionHelp': 'Position moyenne (0 = première séance, 1 = dernière) des cartes de chaque couleur, parcours de 3 séances et plus.',
  'obs.journeys.early': 'Cartes du début',
  'obs.journeys.late': 'Cartes de la fin',
  'obs.journeys.lengths': 'Longueur des parcours',
  'obs.journeys.lengthsHelp': 'Nombre de séances avec cartes par personne.',
  'obs.journeys.colourTransitions': 'D’une famille à l’autre',
  'obs.journeys.colourTransitionsHelp': 'D’une séance à la suivante : part (en %) des cartes de la couleur de la ligne suivies par la couleur de la colonne.',
  'obs.journeys.transitions': 'Ce qui suit quoi',
  'obs.journeys.transitionsHelp': 'Carte prise à la séance n, carte prise à la séance n+1 par la même personne (au moins 3 fois).',
  'obs.journeys.surprising': 'Enchaînements marquants',
  'obs.journeys.surprisingHelp': 'Les enchaînements qui dépassent le plus le hasard (au moins 4 fois).',
  'obs.profiles.intro': 'Regroupement de {n} participant·es (3 cartes et plus) selon les couleurs qu’ils et elles travaillent — même méthode pour tout le monde, k-means sur les parts de couleurs.',
  'obs.profiles.k': 'Nombre de profils',
  'obs.profiles.notEnough': 'Pas assez de participant·es pour cette période.',
  'obs.profiles.meanEntries': 'séances en moyenne :',
  'obs.profiles.presence': 'présence',
  'obs.profiles.topCards': 'Cartes typiques (part des membres, lift vs tout le monde)',
  'obs.profiles.deltas': 'Observations : évolution moyenne première → dernière lettre',
  'obs.profiles.members': 'Membres',
  'obs.obs.takers': 'preneurs',
  'obs.obs.others': 'autres',
  'obs.obs.withLetters': 'entrées avec lettres',
  'obs.obs.deltaHelp': 'Première → dernière lettre par personne ;',
  'obs.obs.mean': 'moyenne',
  'obs.obs.byIndex': 'Les lettres au fil des séances',
  'obs.obs.byIndexHelp': 'Moyenne des lettres (A = 1 … E = 5) à la 1re, 2e, … séance de chaque personne. La taille du point suit le nombre de personnes.',
  'obs.obs.takesByIndex': 'Prise des cartes au fil des séances',
  'obs.obs.takesByIndexHelp': 'Part des personnes qui prennent les cartes, séance après séance.',
  'obs.obs.assocPos': 'Cartes associées à une progression',
  'obs.obs.assocNeg': 'Cartes associées à un recul',
  'obs.obs.assocHelp': 'Différence d’évolution moyenne (première → dernière lettre) entre les personnes qui ont pris la carte et les autres. Une association, pas une cause : les personnes qui prennent une carte ne sont pas les mêmes que les autres.',
  'obs.themes.intro': 'Le modèle lit les contextes, notes et défis saisis, propose une grille de thèmes à partir de ce que les gens expriment (au-delà du vocabulaire du jeu), classe chaque extrait, puis rédige des lectures pour la planification. Quelques minutes de calcul sur le serveur interne ; rien ne sort du réseau.',
  'obs.themes.aiOff': 'Le service IA n’est pas configuré sur cet environnement.',
  'obs.themes.recompute': 'Calculer',
  'obs.themes.running': 'Calcul en cours…',
  'obs.themes.error': 'Le calcul a échoué :',
  'obs.themes.none': 'Aucun calcul pour l’instant — lancez-le.',
  'obs.themes.computed': 'Calculé le',
  'obs.themes.texts': 'extraits',
  'obs.themes.unassigned': 'non classés',
  'obs.themes.readings': 'Lectures pour la planification',
  'obs.themes.readingsHelp': 'Rédigées par le modèle à partir des chiffres ci-dessous — à relire comme des hypothèses de travail.',
  'obs.themes.grid': 'Les thèmes qui ressortent',
  'obs.themes.gridHelp': 'Volume d’extraits, personnes concernées, cartes associées, évolution par trimestre, et quelques extraits représentatifs.',
  'obs.themes.examples': 'Extraits',
  'obs.themes.pairs': 'Thèmes qui vont ensemble',
  'obs.themes.pairsHelp': 'Deux thèmes présents dans la même entrée.',
  'obs.adh.noEveil': 'Séances Éveil indisponibles : l’adhésion ne peut pas être calculée.',
  'obs.adh.withSeances': 'intervenant·es avec séances',
  'obs.adh.using': 'utilisent le jeu',
  'obs.adh.notUsing': 'ne l’utilisent pas',
  'obs.adh.adherence': 'adhésion',
  'obs.adh.heldRecorded': 'séances saisies / tenues',
  'obs.adh.participants': 'participant·es saisi·es / planifié·es',
  'obs.adh.participantsHelp': 'Personnes avec au moins une entrée, sur les personnes planifiées à un Espace Évolution dans la période.',
  'obs.adh.completeRate': 'entrées complètes',
  'obs.adh.bspAdhoc': 'BSP · ad hoc saisis',
  'obs.adh.weekly': 'Semaine par semaine',
  'obs.adh.weeklyHelp': 'Séances Espace Évolution tenues (Éveil) et celles saisies dans Evolution.',
  'obs.adh.recorded': 'saisies',
  'obs.adh.notRecorded': 'non saisies',
  'obs.adh.table': 'Par intervenant·e',
  'obs.adh.tableHelp': 'Tenues = séances Espace Évolution de la personne dans le planning Éveil (non annulées). Saisies = ouvertes dans Evolution avec au moins une entrée renseignée. Les taux portent sur les entrées saisies.',
  'obs.adh.intervenant': 'Intervenant·e',
  'obs.adh.held': 'Tenues',
  'obs.adh.recordedShort': 'Saisies',
  'obs.adh.weeks': 'Semaines',
  'obs.adh.cards': 'Cartes',
  'obs.adh.context': 'Contexte',
  'obs.adh.defi': 'Défi',
  'obs.adh.letters': 'Lettres',
  'obs.adh.complete': 'Complètes',
  'obs.adh.lag': 'Délai',
  'obs.adh.lagHelp': 'Jours entre la séance et son ouverture dans Evolution (médiane).',
  'obs.adh.last': 'Dernière saisie',
  'obs.adh.locations': 'Lieux',
  'obs.adh.openedOnly': 'ouvertes sans entrée renseignée',
  'obs.adh.byLocation': 'Par lieu',
  'obs.status.actif': 'actif·ve',
  'obs.status.partiel': 'partiel',
  'obs.status.inactif': 'inactif·ve',
  'obs.status.sans_seance': 'sans séance',
  'obs.status.hors_eveil': 'hors planning',
};

const en: Dict = {
  'brand.title': 'Evolution',
  'brand.subtitle': 'Espace Evolution',
  'nav.upcoming': 'Sessions',
  'nav.admin': 'Admin',
  'common.logout': 'Logout',
  'common.loading': 'Loading…',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.add': 'Add',
  'common.back': 'Back',
  'common.close': 'Close',
  'common.saving': 'saving…',
  'common.search': 'Search',
  'common.theme.light': 'Light mode',
  'common.theme.dark': 'Dark mode',
  'common.language': 'Language',
  'common.impersonating': 'Viewing as',
  'common.impersonatingBy': 'impersonated by',
  'common.stopImpersonating': 'Stop impersonating',
  'shell.devBanner.label': 'DEV environment',
  'shell.devBanner.text': 'Test environment — what you enter here is not carried over to the app and may be wiped at any time. For real sessions, use:',

  'login.title': 'Evolution',
  'login.subtitle': 'Espace Evolution — animator workspace',
  'login.oidcButton': 'Log in with Authentik',
  'login.emailPlaceholder': 'your.name@aeveil.ch',

  'upcoming.past': 'Past sessions',
  'upcoming.title': 'Sessions',
  'upcoming.next': 'Upcoming',
  'upcoming.today': 'Today',
  'upcoming.showMore': 'Show {n} more upcoming sessions',
  'upcoming.showLess': 'Hide later sessions',
  'upcoming.pastEmpty': 'No past sessions.',
  'upcoming.badge.unopened': 'never opened here',
  'upcoming.newAdHoc': 'New ad-hoc session',
  'upcoming.empty': 'No upcoming sessions. If you animate a Topo Hebdo, check your email matches your Eveil V2 staff record.',
  'upcoming.open': 'Open →',
  'upcoming.openSpace': 'Open the space',
  'upcoming.opening': 'Opening…',
  'upcoming.fill.complete': 'Complete',
  'upcoming.fill.partial': '{a}/{b} recorded',
  'upcoming.fill.todo': 'To record',
  'upcoming.enrolled': '{n} enrolled',
  'upcoming.source.scheduled': 'scheduled',
  'upcoming.source.recurrence': 'computed from recurrence',
  'upcoming.source.adhoc': 'ad-hoc',
  'upcoming.source.bsp': 'bilan — individual review meeting',
  'upcoming.source.intake': 'first interview / socio-professional assessment',
  'upcoming.badge.bilan': 'Bilan',
  'upcoming.badge.bspPlanned': 'BSP',
  'upcoming.bspNotRecorded': 'to record',
  'upcoming.modal.title': 'New ad-hoc session',
  'upcoming.modal.date': 'Date',
  'upcoming.modal.type': 'Session type',
  'upcoming.modal.typeEE': 'Espace Evolution',
  'upcoming.modal.typeBsp': 'Bilan / BSP',
  'upcoming.modal.titleField': 'Title',
  'upcoming.modal.titlePlaceholder': 'e.g., Espace Evolution — Lausanne',
  'upcoming.modal.location': 'Location (optional)',
  'upcoming.modal.create': 'Create & open',
  'upcoming.modal.creating': 'Creating…',

  'session.empty': 'No participants yet.',
  'session.selectParticipant': 'Select a participant to record picks, notes and observations.',
  'session.addParticipant': 'Add participant',
  'session.addNamePlaceholder': 'Name',
  'session.presence.present': 'Present',
  'session.presence.absent': 'Absent',
  'session.presence.expected': 'Expected',
  'session.presence.added': 'Added',
  'session.presence.not_recorded': 'Attendance not recorded',
  'session.status.open': 'open',
  'session.observations': 'Observations:',
  'nav.collapse': 'Collapse',
  'nav.expand': 'Expand menu',
  'session.progress': 'recorded',
  'session.progressHelp': 'Complete entries: presence set and, for those present, the five observations.',
  'session.queueLabel': 'Participants',
  'session.recorded': 'Entry complete',
  'editor.presence': 'Presence',
  'editor.prevSession': 'Previous session',
  'editor.prevSessionNone': 'First recorded session for this participant.',
  'editor.objectives': 'Measure objectives',
  'editor.objectivesNone': 'No objectives recorded in V2 for this participant.',
  'editor.objectivesBy': 'by',

  'bsp.title': 'BSP',
  'bsp.source': 'Source',
  'bsp.sourceLocal': 'BSP stored in Evolution.',
  'bsp.sourceV2': 'BSP fetched from Éveil V2 — save to keep it in Evolution.',
  'bsp.sourceNone': 'No existing BSP — create one.',
  'bsp.date': 'BSP date',
  'bsp.location': 'Location',
  'bsp.referent': 'Referent',
  'bsp.presence': 'Attendance and charter',
  'bsp.mandantPresent': 'Mandant present',
  'bsp.socialAssistantPresent': 'Social worker present',
  'bsp.charterSigned': 'Charter signed',
  'bsp.objectivesSet': 'Objectives (participant’s own words)',
  'bsp.formation': 'Education',
  'bsp.health': 'Health',
  'bsp.psychological': 'Psychological situation',
  'bsp.family': 'Family situation',
  'bsp.medication': 'Medication',
  'bsp.hobbies': 'Interests',
  'bsp.availability': 'Availability',
  'bsp.notes': 'Notes',
  'bsp.save': 'Save',
  'bsp.create': 'Create BSP',
  'bsp.loadError': 'Could not load the BSP.',
  'bsp.saveError': 'Could not save the BSP.',
  'editor.nextParticipant': 'Next participant',
  'session.status.closed': 'closed',

  'editor.cards': 'Cards picked',
  'editor.notes': 'Context notes',
  'editor.notesPlaceholder': 'What did the participant share? Observations on the picked cards…',
  'editor.observations': 'Observations',
  'editor.adhocLabel': 'Ad-hoc',
  'editor.history': 'History',
  'editor.copyReport': 'Copy report',
  'editor.copyReportHelp': 'Copies the picked cards, notes and observations as plain text, ready to paste into a report.',
  'editor.copied': 'Copied!',

  'score.hoverHint': 'Hover or select a level to see its detailed criteria.',
  'score.explainToggle': 'Show explanations',

  // feuille de séance
  'fds.backToSheet': 'Session sheet',
  'fds.open': 'Open →',
  'fds.noCards': 'no cards yet',
  'fds.card': 'card',
  'fds.cards': 'cards',

  // table d'aujourd'hui
  'cards.tableCaption': 'Today’s table',
  'cards.addCard': 'Add a card',
  'cards.wholeDeck': 'Whole deck…',
  'cards.browseDeck': 'Browse the whole deck →',
  'cards.deckTitle': 'The whole deck',
  'cards.recurrence': 'Chosen {n} times across sessions',
  'editor.trends': 'Trends',
  'editor.timeline': 'Session timeline',
  'editor.prevOlder': 'Older session',
  'editor.prevNewer': 'More recent session',
  'editor.objectivesTitle': 'Objectives — in the participant’s words',
  'editor.objectivesSource': 'First interview / BSP of',
  'editor.objectivesInfos': 'Additional information',
  'editor.evolution': '{name}’s evolution',
  'editor.flipToHistory': 'View history',
  'editor.flipToToday': 'Today’s session',
  'editor.backCaption': '{name}’s history',

  // rich notes
  'notes.toolbar': 'Formatting',
  'notes.bold': 'Bold',
  'notes.italic': 'Italic',
  'notes.underline': 'Underline',
  'notes.ul': 'Bulleted list',
  'notes.ol': 'Numbered list',
  'notes.savedAt': 'Saved at',
  'notes.saveError': 'Save failed — edit the text to retry',
  'notes.versions': 'Versions',
  'notes.versionsHelp': 'Save a version of the note or revert to a previous one',
  'notes.saveVersion': 'Save a version',
  'notes.versionSaved': 'Version saved',
  'notes.noVersions': 'No saved versions.',
  'evo.observations': 'Observations · A → E',
  'evo.delta': 'Evolution',
  'participant.journal': 'Session journal',
  'participant.journal.empty': 'No sessions recorded yet.',
  'participant.intake.open': 'First interview details',
  'common.showMore': 'show more',
  'common.showLess': 'show less',

  'report.title': 'ESPACE EVOLUTION — SESSION REPORT',
  'report.participant': 'Participant',
  'report.session': 'Session',
  'report.location': 'Location',
  'report.presence': 'Presence',
  'report.cards': 'CARDS PICKED',
  'report.notes': 'NOTES',
  'report.observations': 'OBSERVATIONS',
  'report.noCards': '(no cards)',
  'report.noNotes': '(no notes)',
  'report.notScored': '(not rated)',

  'cards.noPicks': 'No cards picked yet.',
  'cards.searchPlaceholder': 'Search cards…',
  'cards.noMatches': 'No matches.',
  'cards.picked': 'picked',
  'cards.remove': 'Remove',
  'cards.allCategories': 'All',
  'cards.base': 'Base',
  'cards.supplementary': 'Supplementary',
  'cards.brand': 'L’Eveil',

  'admin.title': 'Admin',
  'admin.tab.users': 'Users',
  'admin.tab.roles': 'Roles',
  'admin.tab.audit': 'Audit log',
  'admin.tab.notifications': 'Notifications',
  'admin.tab.branding': 'Branding',
  'admin.tab.cards': 'Cards',
  'admin.tab.devdata': 'Test data',
  'admin.devData.title': 'Reload data from production',
  'admin.devData.help': 'This test environment has its own database. This button replaces it with a point-in-time copy of the production database (sessions, participants, observations, cards). Access to this test environment and its look are kept. Production is never modified.',
  'admin.devData.lastReload': 'Last reload:',
  'admin.devData.never': 'never',
  'admin.devData.button': 'Reload from production',
  'admin.devData.modalTitle': 'Replace the test data?',
  'admin.devData.modalWarning': 'Everything entered in this test environment will be erased and replaced by a copy of production. This cannot be undone for the test data; production is untouched.',
  'admin.devData.typeReset': 'Type RESET to confirm',
  'admin.devData.confirm': 'Replace the test data',
  'admin.devData.running': 'Reloading…',
  'admin.devData.done': 'Data reloaded from production.',
  'admin.devData.failed': 'The reload failed.',
  'cardver.title': 'Card deck versions',
  'cardver.intro': 'Card inventory per version and lineage from one version to the next.',
  'cardver.current': 'current',
  'cardver.items': 'cards',
  'cardver.number': 'No.',
  'cardver.name': 'Card',
  'cardver.category': 'Category',
  'cardver.metalabel': 'Type',
  'cardver.lineage': 'Becomes (next version)',
  'cardver.dropped': 'dropped',
  'cardver.archived': 'archived',
  'cardver.unchanged': 'unchanged',
  'cardver.renumbered': 'renumbered',
  'cardver.loading': 'Loading…',
  'admin.logo.title': 'Application logo',
  'admin.logo.help': 'Square PNG recommended, transparent background, max 1.5 MB. Displayed in the header bar.',
  'admin.logo.none': 'No logo',
  'admin.logo.upload': 'Upload logo',
  'admin.logo.remove': 'Remove',
  'admin.logo.errPng': 'Only PNG files are accepted.',
  'admin.logo.errSize': 'File too large (max 1.5 MB).',
  'admin.accent.title': 'Accent colour',
  'admin.accent.help': 'The app’s main colour (buttons, links, active elements). Applies immediately, in light and dark mode.',
  'admin.accent.custom': 'Custom colour',
  'admin.accent.reset': 'Restore the default green',

  'history.title': 'Participant history',
  'history.empty': 'No previous sessions recorded for this participant.',
  'history.cardsOverTime': 'Cards over time',
  'history.cardsHelp': 'One row per distinct card, one column per session. Recurring patterns stand out.',
  'history.recurrenceCount': 'times',
  'history.scores': 'Observation evolution',
  'history.sessions': 'Sessions',
  'history.notes': 'Notes',
  'history.noPicks': '(no cards)',
  'history.noScore': '—',

  // my participants
  'nav.myParticipants': 'My Participants',
  'participants.title': 'My Participants',
  'participants.empty': 'No participants met yet.',
  'participants.lastSession': 'Last Espace Evolution',
  'participants.nextSession': 'Next Espace Evolution',
  'participants.attendance': 'Attendances',
  'participants.sessions': 'sessions',
  'participants.session': 'session',
  'participants.since': 'since',
  'participants.presencesOf': 'attendances over',
  'participants.themesTitle': 'Recurring themes',
  'participants.upcoming': 'upcoming',
  'participants.today': 'today',
  'participants.tomorrow': 'tomorrow',
  'participants.inPrefix': 'in',
  'participants.daysUnit': 'days',
  'participants.cadence': 'Cadence',
  'participants.week': 'week',
  'participants.weeks': 'weeks',
  'participants.dayUnit': 'day',
  'participants.firstMeeting': 'first meeting',
  'participants.reference': 'Reference',
  'participants.referenceTitle': 'You are this participant’s measure referent.',
  'participants.noSessionsYet': 'no recorded session yet',
  'participant.notFound': 'Participant not found.',
  'participant.objectives': 'Objectives',
  'participant.objectives.local': 'Objectives (participant’s own words)',
  'participant.objectives.localSource': 'BSP recorded in Evolution',
  'participant.objectives.own': 'Objectives in their own words',
  'participant.objectives.means': 'Means to achieve them',
  'participant.objectives.ownSource': 'First interview sheet (scanned BSP)',
  'participant.objectives.intakeSource': 'First interview / BSP',
  'participant.bspCards': 'Cards chosen at the BSP',
  'participant.objectives.structured': 'Intake objectives',
  'participant.objectives.journal': 'Action plans',
  'participant.objectives.empty': 'No objectives found.',
  'participant.info': 'First interview / BSP',
  'participant.info.empty': 'No additional information.',
  'participant.info.date': 'Interview of',
  'participant.info.notes': 'Additional information',
  'participant.info.formation': 'Training / background',
  'participant.info.health': 'Health',
  'participant.info.psychological': 'Psychological situation',
  'participant.info.family': 'Family situation',
  'participant.info.medication': 'Medication',
  'participant.info.hobbies': 'Hobbies & interests',
  'participant.info.availability': 'Availability',
  'participant.picks.current': 'Cards picked',
  'participant.picks.history': 'Card history',
  'participant.picks.empty': 'No cards picked yet.',
  'participant.observations': 'Observations',
  'participant.observations.empty': 'No observations recorded.',
  'participant.v2Unavailable': 'Eveil V2 data is currently unavailable.',

  // profile menu
  'profile.title': 'Profile',
  'profile.menuAria': 'Open profile menu',

  // login (kit labels)
  'login.emailLabel': 'Email',
  'login.passwordLabel': 'Password',
  'login.passwordPlaceholder': 'Enter your password',
  'login.submit': 'Log in',
  'login.submitting': 'Logging in…',
  'login.footer.open': 'Open registration — first user becomes admin',
  'login.footer.allowlist': 'Only pre-approved email addresses can log in',
  'login.err.emailRequired': 'Email is required',
  'login.err.passwordRequired': 'Password is required',
  'login.err.loginFailed': 'Login failed',
  'login.err.notAuthorized': 'Your email is not authorized to access this application. Contact an administrator.',
  'login.err.oidcFailed': 'Authentication failed. Please try again.',
  'login.err.noEmail': 'No email was received from the identity provider.',

  // admin — user management (kit labels)
  'users.regMode.title': 'Registration mode',
  'users.regMode.open': 'Open',
  'users.regMode.allowlist': 'Allowlist',
  'users.regMode.openHelp': 'Anyone with a valid email can register. The first user becomes admin.',
  'users.regMode.allowlistHelp': 'Only pre-approved emails can log in.',
  'users.allowlist.title': 'Email allowlist',
  'users.allowlist.notEnforced': 'The allowlist is not currently enforced. Switch to Allowlist mode to restrict registration.',
  'users.allowlist.helpEnforced': 'Only these email addresses can log in. Add emails before users authenticate.',
  'users.allowlist.helpNotEnforced': 'Manage emails for when you switch to Allowlist mode.',
  'users.emailPlaceholder': 'email@example.com',
  'users.namePlaceholder': 'Name (optional)',
  'users.addToAllowlist': 'Add to allowlist',
  'users.createAccount': 'Create account',
  'users.errValidEmail': 'Valid email is required',
  'users.col.email': 'Email',
  'users.col.status': 'Status',
  'users.col.added': 'Added',
  'users.status.registered': 'Registered ({name})',
  'users.status.pending': 'Pending',
  'users.impersonate': 'Impersonate',
  'users.remove': 'Remove',
  'users.confirmRemoveEmail': 'Remove "{email}" from the allowlist?',
  'users.mgmt.title': 'User management',
  'users.col.user': 'User',
  'users.col.role': 'Role',
  'users.col.joined': 'Joined',
  'users.badge.admin': 'Admin',
  'users.badge.user': 'User',
  'users.removeAdmin': 'Remove admin',
  'users.makeAdmin': 'Make admin',
  'users.roles': 'Roles',
  'users.resetPassword': 'Reset password',
  'users.delete': 'Delete',
  'users.confirmDelete': 'Delete user "{name}"? This will also delete all their data.',
  'users.newPasswordPlaceholder': 'New password (min 8 chars)',
  'users.set': 'Set',
  'users.saveRoles': 'Save roles',
  'users.errPasswordMin': 'Password must be at least 8 characters',
  'users.passwordResetDone': 'Password reset successfully',

  // admin — audit log (kit labels)
  'audit.allActions': 'All actions',
  'audit.resourceType': 'Resource type',
  'audit.startDate': 'Start date',
  'audit.endDate': 'End date',
  'audit.searchPlaceholder': 'Search…',
  'audit.search': 'Search',
  'audit.clear': 'Clear',
  'audit.col.time': 'Time',
  'audit.col.user': 'User',
  'audit.col.action': 'Action',
  'audit.col.resourceType': 'Resource type',
  'audit.col.resourceId': 'Resource ID',
  'audit.col.details': 'Details',
  'audit.col.ip': 'IP',
  'audit.loading': 'Loading…',
  'audit.empty': 'No audit log entries found',
  'audit.loadFailed': 'Failed to load audit log',
  'audit.clickToExpand': 'Click to expand',
  'audit.totalEntries': '{n} total entries',
  'audit.pageOf': 'Page {page} of {pages}',
  'audit.prev': 'Previous',
  'audit.next': 'Next',

  // admin — notification preferences (kit labels)
  'notif.title': 'Notification preferences',
  'notif.loading': 'Loading preferences…',
  'notif.sponsorBadge': 'Sponsor',
  'notif.all': 'All notifications',
  'notif.sponsoredOnly': 'Sponsored only',

  // ── PV ae45 (2026-10): attribution, roster, per-card context, défi, usage ──
  'nav.cards': 'Cards',
  'session.animatedBy': 'Led by',
  'session.animatedByHelp': 'The person leading the session. Any intervenant can record here; entries recorded by someone else are flagged.',
  'session.you': 'you',
  'session.recordedBy': 'recorded by',
  'session.addSearchPlaceholder': 'Search a person in Éveil…',
  'session.addHelp': 'Type at least two letters of the name. Full name and measure are shown to tell namesakes apart.',
  'session.addNoResults': 'Nobody found in Éveil.',
  'session.addOnlyInMeasure': 'In measure only',
  'session.inMeasure': 'in measure',
  'session.notInMeasure': 'out of measure',
  'session.linkToEveil': 'Link to Éveil',
  'session.linkToEveilHelp': 'Attach this entry to an Éveil record to recover its history.',
  'session.linkConflict': 'This person is already in the session.',
  'session.removeParticipant': 'Remove from session',
  'session.removeConfirm': 'Remove {name} from this session? The entry stays recoverable.',
  'session.removed': 'Removed from the session:',
  'session.removedBy': 'by',
  'session.restoreParticipant': 'Put back',
  'session.replaceAnimator': 'Replace the leader',
  'session.replaceAnimatorHelp': 'Who leads this session?',
  'session.deck': 'Deck',
  'session.deckHelp': 'Card deck used in this session — derived from the picks unless set.',
  'session.deck.base': 'base',
  'session.deck.complet': 'full',
  'session.delete': 'Delete session',
  'session.deleteHelp': 'The session goes to the trash; it can be restored.',
  'session.deleteConfirm': 'Delete this session? It stays recoverable from the trash at the bottom of the sessions list.',
  'session.deleted': 'Session deleted',
  'session.deletedBy': 'by',
  'session.restore': 'Restore',
  'upcoming.scope': 'Scope',
  'upcoming.scope.mine': 'My sessions',
  'upcoming.scope.all': 'All sessions',
  'upcoming.trash': 'Trash · {n}',
  'upcoming.trashRestore': 'Restore',
  'upcoming.trashParticipants': '{n} participants',
  'upcoming.deletedBy': 'deleted by',
  'editor.recap': 'Goals & BSP',
  'editor.recapNone': 'No goals or BSP recorded in Éveil.',
  'editor.recapGoals': 'Sponsor',
  'editor.recapProgression': 'Intermediate goal:',
  'editor.recapBsp': 'BSP',
  'editor.recapBspCards': 'BSP cards',
  'editor.pickMeta': 'Around each card',
  'editor.pickMetaHelp': 'For each card: what was said (the context), the horizon — short, medium or long term — and the workshops where the theme can be worked on.',
  'editor.contextPlaceholder': 'What was said around “{card}”…',
  'editor.horizon': 'Horizon',
  'editor.ateliers': 'Workshops',
  'editor.ateliersProgramme': 'On {name}’s programme',
  'editor.ateliersOthers': 'Other workshops',
  'editor.ateliersNone': 'No workshop on the programme.',
  'editor.ateliersFilter': 'Search a workshop…',
  'editor.defi': 'Challenge of the week',
  'editor.defiPlaceholder': 'One concrete step before the next session, in the person’s words…',
  'editor.prevDefi': 'Challenge:',
  'evo.colourMix': 'Colours',
  'evo.neverTaken': 'Never taken:',
  'evo.noContext': 'no context',
  'evo.oldDeck': 'Old deck',
  'report.animator': 'Leader',
  'report.ateliers': 'Workshops:',
  'report.defi': 'CHALLENGE OF THE WEEK',
  'report.noDefi': '(no challenge)',
  'participants.titleAll': 'Participants',
  'participants.scope': 'Scope',
  'participants.scope.mine': 'Mine',
  'participants.scope.all': 'All',
  'participants.showArchived': 'Show archived',
  'participants.archived': 'Archived',
  'participants.archivedHelp': 'No session for six months, no reference and no next session — or hidden by hand.',
  'participants.hidden': 'Hidden',
  'participants.hide': 'Hide from the list',
  'participants.unhide': 'Show again',
  'participants.animators': 'Leaders:',
  'usage.title': 'Card usage',
  'usage.intro': 'Which cards and colours come back, which never do, which go together — the material for the deck overhaul.',
  'usage.period': 'Period',
  'usage.period.all': 'All time',
  'usage.period.12m': 'Last 12 months',
  'usage.period.6m': 'Last 6 months',
  'usage.kpi.picks': 'cards taken',
  'usage.kpi.entries': 'entries with cards',
  'usage.kpi.sessions': 'sessions',
  'usage.kpi.participants': 'participants',
  'usage.kpi.supplementary': 'full deck (cards 41–55)',
  'usage.kpi.never': 'cards never taken',
  'usage.byColour': 'By colour',
  'usage.byCard': 'By card',
  'usage.col.participantsShort': 'people',
  'usage.col.picks': 'Picks',
  'usage.col.participants': 'Participants',
  'usage.col.sessions': 'Sessions',
  'usage.col.context': 'With context',
  'usage.col.last': 'Last pick',
  'usage.sort.picks': 'Sort: picks',
  'usage.sort.participants': 'Sort: participants',
  'usage.sort.sessions': 'Sort: sessions',
  'usage.sort.last': 'Sort: last pick',
  'usage.sort.number': 'Sort: number',
  'usage.horizons': 'Horizons:',
  'usage.pairs': 'Cards that go together',
  'usage.pairsHelp': 'Pairs taken by the same person in the same session — candidate duplicates to merge.',
  'usage.never': 'Never taken',
  'usage.neverNone': 'Every active card has been taken at least once.',
  'evo.colours': 'Colours — cards per colour and per session',
  'evo.more': 'more and more',
  'evo.less': 'less and less',
  'evo.same': 'steady',
  'evo.dimensions': 'The five dimensions',
  'evo.synthesisNote': '✦ Per-card synthesis written by the AI from the recorded contexts, notes and challenges — review before use.',
  'evo.synthesisPending': 'Per-card synthesis being written…',
  'evo.synthesisError': 'The per-card synthesis could not be generated (AI service unavailable).',

  // ── Observatoire ──
  'nav.insights': 'Observatory',
  'obs.title': 'Observatory',
  'obs.intro': 'What all the Espaces Évolution say together: which themes, together, in what order, for whom, with what movement — and who records what.',
  'obs.period': 'Period',
  'obs.period.all': 'All history',
  'obs.period.365': 'Last 12 months',
  'obs.period.180': 'Last 6 months',
  'obs.period.90': 'Last 3 months',
  'obs.tab.overview': 'Overview',
  'obs.tab.together': 'Cards together',
  'obs.tab.journeys': 'Journeys',
  'obs.tab.profiles': 'Profiles',
  'obs.tab.observations': 'Observations',
  'obs.tab.themes': 'Emerging themes',
  'obs.tab.adherence': 'Adherence',
  'obs.kpi.participants': 'participants',
  'obs.kpi.sessions': 'sessions',
  'obs.kpi.entries': 'entries',
  'obs.kpi.entriesHelp': 'An entry = one participant at one session, with at least a card, a note, a challenge or an observation.',
  'obs.kpi.picks': 'cards taken',
  'obs.kpi.picksPerEntry': 'cards per entry',
  'obs.kpi.contextRate': 'cards with context',
  'obs.kpi.defiRate': 'entries with challenge',
  'obs.kpi.lettersRate': 'entries with observations',
  'obs.kpi.takesCards': 'take cards',
  'obs.kpi.repeatRate': 'cards taken again',
  'obs.kpi.repeatHelp': 'Share of cards the same person had already taken at an earlier session: continuity of themes.',
  'obs.overview.monthly': 'Colours month by month',
  'obs.overview.monthlyHelp': 'Cards taken each month, stacked by colour (last 12 months). The programme’s seasons and the weight of each family of themes.',
  'obs.cardsWord': 'cards',
  'obs.seancesWord': 'sessions',
  'obs.peopleShort': 'people',
  'obs.daysWord': 'days',
  'obs.none': 'Nothing to show for this period.',
  'obs.card': 'Card',
  'obs.overview.colours': 'By colour',
  'obs.overview.coloursHelp': 'Cards taken and distinct people per family.',
  'obs.overview.topCards': 'Most taken cards',
  'obs.overview.rising': 'Rising',
  'obs.overview.falling': 'Falling',
  'obs.overview.trendHelp': 'Share of entries where the card is taken: last 3 months against the 3 months before (percentage points).',
  'obs.together.entries': 'Computed on {n} entries with at least two cards.',
  'obs.together.minSupport': 'Pairs seen at least',
  'obs.together.graph': 'The deck as it is actually played',
  'obs.together.graphHelp': 'Each dot is a card (size = frequency, colour = family). A line joins two cards taken together in the same session more often than chance (lift > 1); the thicker, the stronger. Clumps are themes that hold together.',
  'obs.together.communities': 'Clusters',
  'obs.together.communitiesHelp': 'Groups of cards that attract each other (label propagation on the graph). Candidates for thematic workshops, or for merging in the deck overhaul.',
  'obs.together.colours': 'Families taken together',
  'obs.together.coloursHelp': 'How many sessions brought two colour families together.',
  'obs.together.pairs': 'Most frequent pairs',
  'obs.together.pairsHelp': '“Expected” = frequency if both cards were taken independently; lift = observed / expected.',
  'obs.together.lift': 'Most linked pairs',
  'obs.together.liftHelp': 'Pairs whose link most exceeds chance (at least 4 occurrences).',
  'obs.together.n': 'Seen',
  'obs.together.expected': 'Expected',
  'obs.journeys.from': 'Session n',
  'obs.journeys.to': 'Session n+1',
  'obs.journeys.threePlus': 'journeys of 3+ sessions',
  'obs.journeys.meanLength': 'sessions per person',
  'obs.journeys.steps': 'transitions',
  'obs.journeys.stepsHelp': 'Pairs of consecutive sessions of the same person.',
  'obs.journeys.phases': 'Beginning, middle, end',
  'obs.journeys.phasesHelp': 'Each journey of 3+ sessions is cut into thirds; share of each colour in each third. The expected migration from deep themes to concrete ones reads here.',
  'obs.phase.debut': 'Beginning',
  'obs.phase.milieu': 'Middle',
  'obs.phase.fin': 'End',
  'obs.journeys.repeats': 'cards taken again',
  'obs.journeys.position': 'Where each family sits in the journey',
  'obs.journeys.positionHelp': 'Mean position (0 = first session, 1 = last) of each colour’s cards, journeys of 3+ sessions.',
  'obs.journeys.early': 'Early cards',
  'obs.journeys.late': 'Late cards',
  'obs.journeys.lengths': 'Journey lengths',
  'obs.journeys.lengthsHelp': 'Sessions with cards per person.',
  'obs.journeys.colourTransitions': 'From one family to the next',
  'obs.journeys.colourTransitionsHelp': 'From one session to the next: share (%) of the row colour’s cards followed by the column colour.',
  'obs.journeys.transitions': 'What follows what',
  'obs.journeys.transitionsHelp': 'Card taken at session n, card taken at session n+1 by the same person (at least 3 times).',
  'obs.journeys.surprising': 'Notable sequences',
  'obs.journeys.surprisingHelp': 'Sequences that most exceed chance (at least 4 times).',
  'obs.profiles.intro': 'Grouping of {n} participants (3+ cards) by the colours they work on — same method for everyone, k-means on colour shares.',
  'obs.profiles.k': 'Number of profiles',
  'obs.profiles.notEnough': 'Not enough participants for this period.',
  'obs.profiles.meanEntries': 'sessions on average:',
  'obs.profiles.presence': 'presence',
  'obs.profiles.topCards': 'Typical cards (share of members, lift vs everyone)',
  'obs.profiles.deltas': 'Observations: mean first → last letter change',
  'obs.profiles.members': 'Members',
  'obs.obs.takers': 'takers',
  'obs.obs.others': 'others',
  'obs.obs.withLetters': 'entries with letters',
  'obs.obs.deltaHelp': 'First → last letter per person;',
  'obs.obs.mean': 'mean',
  'obs.obs.byIndex': 'Letters across sessions',
  'obs.obs.byIndexHelp': 'Mean letter (A = 1 … E = 5) at each person’s 1st, 2nd, … session. Dot size follows the number of people.',
  'obs.obs.takesByIndex': 'Card-taking across sessions',
  'obs.obs.takesByIndexHelp': 'Share of people taking cards, session after session.',
  'obs.obs.assocPos': 'Cards associated with progress',
  'obs.obs.assocNeg': 'Cards associated with decline',
  'obs.obs.assocHelp': 'Difference in mean change (first → last letter) between people who took the card and the others. An association, not a cause: people who take a card are not the same as the others.',
  'obs.themes.intro': 'The model reads the recorded contexts, notes and challenges, proposes a grid of themes from what people express (beyond the deck’s vocabulary), classifies every excerpt, then writes readings for planning. A few minutes on the internal server; nothing leaves the network.',
  'obs.themes.aiOff': 'The AI service is not configured on this environment.',
  'obs.themes.recompute': 'Compute',
  'obs.themes.running': 'Computing…',
  'obs.themes.error': 'The computation failed:',
  'obs.themes.none': 'No computation yet — start one.',
  'obs.themes.computed': 'Computed on',
  'obs.themes.texts': 'excerpts',
  'obs.themes.unassigned': 'unclassified',
  'obs.themes.readings': 'Readings for planning',
  'obs.themes.readingsHelp': 'Written by the model from the figures below — read as working hypotheses.',
  'obs.themes.grid': 'Themes that emerge',
  'obs.themes.gridHelp': 'Excerpt volume, people concerned, associated cards, trend by quarter, and a few representative excerpts.',
  'obs.themes.examples': 'Excerpts',
  'obs.themes.pairs': 'Themes that go together',
  'obs.themes.pairsHelp': 'Two themes present in the same entry.',
  'obs.adh.noEveil': 'Éveil sessions unavailable: adherence cannot be computed.',
  'obs.adh.withSeances': 'intervenants with sessions',
  'obs.adh.using': 'use the game',
  'obs.adh.notUsing': 'do not use it',
  'obs.adh.adherence': 'adherence',
  'obs.adh.heldRecorded': 'sessions recorded / held',
  'obs.adh.participants': 'participants recorded / planned',
  'obs.adh.participantsHelp': 'People with at least one entry, over people planned at an Espace Évolution in the period.',
  'obs.adh.completeRate': 'complete entries',
  'obs.adh.bspAdhoc': 'BSP · ad hoc recorded',
  'obs.adh.weekly': 'Week by week',
  'obs.adh.weeklyHelp': 'Espace Évolution sessions held (Éveil) and those recorded in Evolution.',
  'obs.adh.recorded': 'recorded',
  'obs.adh.notRecorded': 'not recorded',
  'obs.adh.table': 'By intervenant',
  'obs.adh.tableHelp': 'Held = the person’s Espace Évolution sessions in the Éveil planning (not cancelled). Recorded = opened in Evolution with at least one filled entry. Rates are over recorded entries.',
  'obs.adh.intervenant': 'Intervenant',
  'obs.adh.held': 'Held',
  'obs.adh.recordedShort': 'Recorded',
  'obs.adh.weeks': 'Weeks',
  'obs.adh.cards': 'Cards',
  'obs.adh.context': 'Context',
  'obs.adh.defi': 'Challenge',
  'obs.adh.letters': 'Letters',
  'obs.adh.complete': 'Complete',
  'obs.adh.lag': 'Lag',
  'obs.adh.lagHelp': 'Days between the session and its opening in Evolution (median).',
  'obs.adh.last': 'Last recorded',
  'obs.adh.locations': 'Locations',
  'obs.adh.openedOnly': 'opened without a filled entry',
  'obs.adh.byLocation': 'By location',
  'obs.status.actif': 'active',
  'obs.status.partiel': 'partial',
  'obs.status.inactif': 'inactive',
  'obs.status.sans_seance': 'no session',
  'obs.status.hors_eveil': 'outside planning',
};

export const dictionaries: Record<Lang, Dict> = { fr, en };
